import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { QuestionGroupGuidelineProps } from './QuestionGroupGuideline';
import { QuestionGroupGuidelineV2 } from './QuestionGroupGuidelineV2';

export interface QuestionGroupGuidelineCollapseExpandProps extends QuestionGroupGuidelineProps {
  compactContent: any;
  compactEnable?: boolean;
  initialExpandValue?: boolean;
}

export const QuestionGroupGuidelineCollapseExpand = observer(
  (props: QuestionGroupGuidelineCollapseExpandProps) => {
    const { content, compactContent, compactEnable, className, ...rest } = props;

    return (
      <QuestionGroupGuidelineV2
        content={content}
        compactContent={compactContent}
        compactEnable={compactEnable}
        {...rest}
      />
    );
  }
);
